/**
* @private
*/
var b2ContactRegister = /** @class */ (function () {
    function b2ContactRegister() {
    }
    return b2ContactRegister;
}());
export { b2ContactRegister };
